import React from 'react';

import {observer} from "mobx-react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetGroupedRowsViewModel} from "../../models/standings-widget.grouped-rows-view-model";
import {StandingsWidgetController} from "../../standings-widget.controller";
import {StandingsWidgetGroupHeader} from "./standings-widget.group.header";
import styles from "../../styles/standings-widget.module.scss";
import classNames from "classnames";
export class StandingsWidgetGroupProps extends BaseProps {
  group: StandingsWidgetGroupedRowsViewModel;
  controller: StandingsWidgetController;
}

export const StandingsWidgetGroup = observer(({controller, group, children}: StandingsWidgetGroupProps) => {
  const headerProps = {
    controller,
    group
  }

  const groupProps = {
    className: classNames(styles.group_content),
    id: `table-group-container${group.num}`
  }
  return (
    <>
      <StandingsWidgetGroupHeader {...headerProps}/>
      <div {...groupProps}>
        {children}
      </div>
    </>
  )
});
